/**
 * CK_Label LED colours (manual v1.2) — shared by the supervisor panel and the
 * picker colour chooser. `value` is the wire format the ink server expects
 * (note the odd short forms: 'ff00' = green, 'ff' = blue); `css` is the
 * displayable swatch colour.
 */
export const ESL_LED_COLORS = [
  { value: 'ff0000', css: '#ff0000', label: 'Red' },
  { value: 'ff00', css: '#00e000', label: 'Green' },
  { value: 'ff', css: '#2563eb', label: 'Blue' },
  { value: 'ffff00', css: '#eab308', label: 'Yellow' },
  { value: 'ffffff', css: '#f3f4f6', label: 'White' },
  { value: 'ff00ff', css: '#d946ef', label: 'Purple' },
  { value: 'ffff', css: '#06b6d4', label: 'Light blue' }
];

export const DEFAULT_ESL_LED_COLOR = 'ff00';

/**
 * The picker-facing palette (Rhys 2026-08-27): four clearly distinct colours.
 * WHITE is reserved for locator/beacon lights (product-ref pushes, bay
 * locate) so a picker's batch colour never clashes with them. The full
 * ESL_LED_COLORS list stays for supervisor settings.
 */
export const PICKER_LED_COLORS = ['ff', 'ff0000', 'ff00ff', 'ff00']
  .map((value) => ESL_LED_COLORS.find((c) => c.value === value))
  .filter(Boolean);

/**
 * Colours for LOCATE / beacon lights, deliberately disjoint from
 * PICKER_LED_COLORS (Rhys 2026-08-29): a "where is this?" light must never
 * be mistakable for somebody's live pick light.
 */
export const LOCATE_LED_COLORS = ['ffffff', 'ffff00', 'ffff']
  .map((value) => ESL_LED_COLORS.find((c) => c.value === value))
  .filter(Boolean);

export function eslColorCss(value) {
  return ESL_LED_COLORS.find((c) => c.value === value)?.css || '#00e000';
}
